
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress'; // Optional: Progress bar

// Set up Inertia Progress (optional)
InertiaProgress.init();

// Set up Inertia App
createInertiaApp({
    resolve: name => require(`./Pages/${name}.vue`), // This dynamically loads your pages
    setup({ el, App, props }) {
        createApp({ render: () => h(App, props) })
            .mount(el);
    },
});
